export const WINDOW_ROLES = ['train', 'val', 'test', 'exclude'] as const
export type WindowRole = (typeof WINDOW_ROLES)[number]

export interface WindowRoleColors {
  accent: string
  fill: string
}

/* One role palette for the toolbar swatches and the drawn overlay. */
export const WINDOW_ROLE_COLORS: Record<WindowRole, WindowRoleColors> = {
  train: { accent: '#22d3ee', fill: 'rgba(34, 211, 238, 0.12)' },
  val: { accent: '#fb923c', fill: 'rgba(251, 146, 60, 0.12)' },
  test: { accent: '#ef4444', fill: 'rgba(239, 68, 68, 0.12)' },
  exclude: { accent: '#9ca3af', fill: 'rgba(156, 163, 175, 0.14)' },
}

export const windowRoleColors = (role: string | undefined): WindowRoleColors =>
  (WINDOW_ROLE_COLORS as Record<string, WindowRoleColors | undefined>)[
    role ?? 'train'
  ] ?? WINDOW_ROLE_COLORS.train
